__turbopack_context__.v({
  "settings": "AppDesignForm-module-scss-module__Fdp4Kq__settings",
  "settings-details": "AppDesignForm-module-scss-module__Fdp4Kq__settings-details",
  "settings-show": "AppDesignForm-module-scss-module__Fdp4Kq__settings-show",
  "settings-side-menu": "AppDesignForm-module-scss-module__Fdp4Kq__settings-side-menu",
  "settings-wrapper": "AppDesignForm-module-scss-module__Fdp4Kq__settings-wrapper",
});
